import { Descriptions, Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../../../utils";

function DetailsView() {
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const items1 = [
    {
      key: "1",
      label: "Occupation",
      children: activeObjJob?.jobOccupation ?? "N/A",
    },
    {
      key: "2",
      label: "No. of vacancies",
      children: <div>{numberWithCommas(activeObjJob?.jobVacancyCount)}</div>,
    },
    {
      key: "3",
      label: "Area of Study",
      children: activeObjJob?.jobStudyArea ?? "N/A",
    },
    {
      key: "4",
      label: "Job qualification",
      children: activeObjJob?.jobQualification ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "City",
      children: activeObjJob?.jobCity ?? "N/A",
    },
  ];
  return (
    <div className=" mt-[2.5rem]">
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans">
        2. Job Details
      </div>
      <div className="mt-[1rem] mb-[1.5rem]">
        <Divider />
      </div>

      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Basic Information
      </div>

      <Descriptions
        title=""
        column={2}
        colon={false}
        items={items1}
        layout="vertical"
      />

      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Location Information
      </div>

      <Descriptions
        title=""
        column={1}
        colon={false}
        items={items2}
        layout="vertical"
      />
    </div>
  );
}

export default DetailsView;
